import { baseComponents } from "./base/index";
import { formulaireComponents } from "./formulaire/index";
import { filtersComponents } from "./filters/index";
import { datatableComponents } from "./datatable/index";

export const questionnaireComponents = {
  ...baseComponents,
  ...formulaireComponents,
  ...filtersComponents,
  ...datatableComponents,
};
